import React from "react";

import IconButton from "components/common/IconButton";

import styles from "./styles.module.scss";

export default function TooltipButton({ onClick, buttonText = "", hintText, disabled, icon }) {
    return (
        <div className={styles.tooltip}>
            <IconButton disabled={disabled} icon={icon} onClick={disabled ? undefined : onClick}>
                {buttonText}
            </IconButton>
            {hintText && <p className={styles.tooltip__hint}>{hintText}</p>}
        </div>
    );
}
